<!-- Maintenance page - consistent with login layout and company logos -->
<div id="container" class="page_accueil maintenance-page">
  <header id="header_accueil" class="maintenance-header">
    <div class="block_left header_logo">
      <div id="logo_organic_alliance" class="brand">
        <a href="https://www.organic-alliance.com" target="_blank" rel="noopener">
          <img alt="Organic Alliance" src="assets/images/landingPage/logo_organic_alliance.svg">
        </a>
      </div>
      <div class="zone_accueil">
        <h1 class="welcome-title">{{ title }}</h1>
        <p class="subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <div class="block_right header-features">
      <ul class="fonction" aria-hidden="true">
       
      </ul>
    </div>
  </header>

  <main id="main_information" role="main" class="maintenance-main">
    <section class="block_left">
      <div class="maintenance-box" role="region" aria-labelledby="maintenance-title">
        <img class="maintenance-illustration" [src]="illustration" alt="maintenance illustration">
        <h2 id="maintenance-title">Maintenance en cours</h2>
        <p class="lead">Nous travaillons actuellement sur de nouvelles fonctionnalités pour améliorer votre espace client. </p>

        <p>Notre extranet sera en maintenance aujourd’hui de <b>13h30</b> à <b>13h45</b>. <br> Le site sera temporairement indisponible durant cette période.</p>
        <p>Merci pour votre compréhension et à très vite ! 🚀</p>

        <div class="actions" role="group" aria-label="Actions">
          <button class="btn primary" (click)="goHome()" type="button">Retour à l'accueil</button>
          
        </div>

        <div class="status-note">
          <p>Nous mettons tout en œuvre pour rétablir le service rapidement. Merci de votre patience.</p>
          <p class="small">Si besoin urgent, écrivez à <a [href]="'mailto:' + contactEmail">{{ contactEmail }}</a></p>
        </div>
      </div>
    </section>

    <aside class="block_right" aria-label="Informations">
      <div class="box partners-box">
        <h3>Nous contacter</h3>
        <div class="partners">
          <a href="https://www.pronatura.com" target="_blank" rel="noopener" class="partner">
            <img alt="Pronatura" src="assets/images/landingPage/logo_pronatura.svg">
          </a>
          <a href="https://www.vitafrais.fr" target="_blank" rel="noopener" class="partner">
            <img alt="Vitafrais" src="assets/images/landingPage/logo_vitafrais.svg">
          </a>
        </div>

        <div class="contact-cards">
          <div class="contact-card">
            <strong>Pronatura</strong>
            <a href="mailto:info@pronatura.com">info@pronatura.com</a>
            <div class="phone"><a href="tel:+33490787300">+33 (0)4 90 78 73 00</a></div>
          </div>
          <div class="contact-card">
            <strong>Vitafrais</strong>
            <a href="mailto:vitafrais@vitafrais.fr">vitafrais@vitafrais.fr</a>
            <div class="phone"><a href="tel:+33326878686">+33 (0)3 26 87 86 86</a></div>
          </div>
        </div>
      </div>
    </aside>
  </main>
</div>


